module.exports = {"210282001":"丰荣街道","210282002":"铁西街道","210282003":"太平街道","210282004":"南山街道","210282005":"皮口街道","210282006":"城子坦街道","210282007":"大刘家街道","210282008":"杨树房街道","210282009":"大谭街道","210282010":"唐家房街道","210282011":"莲山街道","210282012":"炮台街道","210282013":"复州湾街道","210282014":"石河街道","210282015":"三十里堡街道","210282106":"双塔镇","210282107":"安波镇","210282108":"四平镇","210282109":"沙包镇","210282117":"星台镇","210282206":"墨盘乡","210282208":"同益乡","210282209":"乐甲满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210282.json
// module id = 475
// module chunks = 0